import { Link } from "react-router";
import { LogIn } from "lucide-react";
import { PublicShell } from "@/components/gettingIn/PublicShell";
import { Column, StatusHead } from "@/components/gettingIn/parts";
import { kitButtonClass } from "@/app/routes/dashboard/components/kit/Button";
import { cn } from "@/utils/helpers";

/**
 * Where the old emailed review links land (/client/calendar/:token and
 * /client/strategy/:token). Review links are gone: a brand's client reviews from
 * their own account as a Guest. This page only says so and points at sign-in,
 * in the public frame like not found: a status and one pill.
 */
export default function ClientLinkMovedView() {
  return (
    <PublicShell title="Reviews have moved">
      <Column>
        <StatusHead icon={LogIn} title="Reviews have moved to your account">
          <p>
            We no longer send review links. Your content calendars, creative briefs and strategies are
            now in your Mohtawa account, where you can review and approve them whenever you like.
          </p>
          <p className="mt-3">
            Sign in to continue. If you don&apos;t have an account yet, ask your contact to invite you.
          </p>
        </StatusHead>
        <Link
          to="/login"
          className={cn(
            kitButtonClass({ variant: "primary", size: "lg" }),
            "unstyled-link h-12 w-full gap-2.5 px-[22px] text-[15px] font-semibold",
            "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-co-accent",
          )}
        >
          Sign in
        </Link>
      </Column>
    </PublicShell>
  );
}
